import Spacings from "../../../../../../packages/design-system/src/Spacings/index.tsx";
import Layer from "../../../../../../packages/design-system/src/Layer/index.tsx";
import * as React from 'react';
export default {
  Spacings,
  Layer,
  React
};